import React from 'react';
import { FormattedMessage } from 'react-intl';
import dayjs from 'dayjs';

import { Wrapper, TimeIcon } from './expiringBlock.styles';

export interface ExpiringBlockProps {
  liveEndAt: string;
  className?: string;
  isMobileVersion?: boolean;
}

export const ExpiringBlock = ({ liveEndAt, className, isMobileVersion }: ExpiringBlockProps) => {
  return (
    <Wrapper isMobileVersion={isMobileVersion} className={className}>
      <TimeIcon />
      <FormattedMessage
        id="detailsBlock.expiringDate"
        defaultMessage="Available until {br} {date}."
        values={{ date: dayjs(liveEndAt).format('h:mm A, MMM D, YYYY'), br: isMobileVersion ? null : <br /> }}
      />
    </Wrapper>
  );
};
